// Date & Time Formater
import useLocalStorage from '../hooks/useLocalStorage'

const month = new Array()
month[0] = 'January'
month[1] = 'February'
month[2] = 'March'
month[3] = 'April'
month[4] = 'May'
month[5] = 'June'
month[6] = 'July'
month[7] = 'August'
month[8] = 'September'
month[9] = 'October'
month[10] = 'November'
month[11] = 'December'

// Format given date to ISO format (while keeping timezone)
function toIsoString(date) {
  const timezoneOffset = -date.getTimezoneOffset(),
    dif = timezoneOffset >= 0 ? '+' : '-',
    pad = function (num) {
      return (num < 10 ? '0' : '') + num
    }

  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) +
    dif + pad(Math.floor(Math.abs(timezoneOffset) / 60)) +
    ':' + pad(Math.abs(timezoneOffset) % 60)
}

// Format date to current Eastern Time
export function dateFormat(date) {
  // Get time zone offset to make time in GTM+0 zone (UTC)
  const timezoneOffset = new Date().getTimezoneOffset()
  const inputDate = new Date(date)
  inputDate.setMinutes(inputDate.getMinutes() + timezoneOffset)

  // For DayLight Saving, ET become 4 hours behind UTC and offset is -240 minutes. When Day light is not active, the offset is -300 minutes.
  const easternTimeOffset = -240
  inputDate.setMinutes(inputDate.getMinutes() + easternTimeOffset);

  const formatedISOdate = toIsoString(inputDate)
  return formatedISOdate
}

// Return the current date formated as an ISO date (UCT)
export function currentISOdate() {
  const currentDate = new Date()

  // Dev/Staging testing tool that bypass current date (for promo testing)
  if (process.env.GATSBY_ENV === 'dev' || process.env.GATSBY_ENV === 'stg') {
    const storedDate = useLocalStorage('get', 'BhvrDevToolsTime')
    if (storedDate && storedDate !== null) {
      currentDate = storedDate
    }
  }

  const date = `${currentDate.getUTCDate()} ${month[currentDate.getUTCMonth()]} ${currentDate.getUTCFullYear()} ${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()} UTC`
  const standardDate = new Date(date)
  const currentISOdate = standardDate.toISOString()
  return currentISOdate
}

// Return the current date formated in specific timezone
export function timezoneDate(timezone) {
  let formatedDate = ''
  if (timezone === 'PST') {
    timezone = 'America/Los_Angeles'
  } else if (timezone === 'EST') {
    timezone = 'America/New_York'
  } else {
    timezone = 'UTC'
  }
  formatedDate = new Date().toLocaleString('en-EN', {
    timeZone: timezone
  })

  // Dev/Staging testing tool that bypass current date (for promo testing)
  if (process.env.GATSBY_ENV === 'dev' || process.env.GATSBY_ENV === 'stg') {
    const storedDate = useLocalStorage('get', 'BhvrDevToolsTime')
    if (storedDate && storedDate !== null) {
      formatedDate = storedDate
    }
  }

  const newFormatedDate = new Date(formatedDate)
  const newFormatedDate2 = new Date(newFormatedDate.setMinutes(newFormatedDate.getMinutes() - newFormatedDate.getTimezoneOffset()))
  const formatedISOdate = newFormatedDate2.toISOString()
  return formatedISOdate
}

// Return formated blog dates from ISO format
export function formatISOdate(date, locale) {
  let language = 'en-EN'
  if (locale === 'en') {
    language = 'en-EN'
  } else if (locale === 'fr') {
    language = 'fr-FR'
  } else if (locale === 'es') {
    language = 'es-ES'
  } else if (locale === 'de') {
    language = 'de-DE'
  } else if (locale === 'it') {
    language = 'it-IT'
  } else if (locale === 'pl') {
    language = 'pl-PL'
  } else if (locale === 'ru') {
    language = 'ru-RU'
  } else if (locale === 'pt') {
    language = 'pt-Pt'
  } else if (locale === 'tr') {
    language = 'tr-TR'
  }

  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  const formatedDate = new Date(date).toLocaleDateString(language, options)

  return formatedDate
}

// Return isolated date elements (Day, Month, Year)
export function getDateElement(date, locale, part, length, type) {
  let dateLength = 'short'
  if (length && length !== null) {
    dateLength = length
  }

  let options = { year: 'numeric', month: dateLength, day: 'numeric' }
  if (part === 'month') {
    options = { month: dateLength } // Output localized month (ex.: May)
  } else if (part === 'day') {
    options = { day: 'numeric' } // Output day (ex.: 23)
  } else if (part === 'year') {
    options = { year: 'numeric' } // Output year (ex.: 2023)
  } else if (part === 'month-day') {
    options = { month: dateLength, day: 'numeric' } // Output localized day and month (ex.: May 23 or 23 mai)
  }

  // Output date only (yyyy-mm-dd)
  let dateElement = new Date(date).toLocaleDateString(locale, options)

  if (type && type === 'dateTime') {
    // Output date and time (yyyy-mm-dd hh:mm:ss)
    options = { hour12: false }
    dateElement = new Date(date).toLocaleString(locale, options)
  }

  return dateElement
}
